// Maps documentCategory to confirmationScreenName
export const MOBILE_UPLOAD_CONFIRMATION_SCREEN_DICT = {
  addEscrow: 'AddEscrowConfirmation',
  addInsurance: 'InsuranceConfirmation',
  legalName: 'EditLegalNameConfirmation',
  militaryStatus: 'EditMilitaryStatusConfirmation',
};
